<template>
  <div>
    <div class="date-input-container">
      <div class="date-field short">
        <v-autocomplete
          v-model="dd"
          placeholder="Ngày (DD)"
          outlined
          dense
          hide-details
          @input="onDayInput"
          @change="onDayChange"
          ref="day"
          :items="days"
        />
      </div>
      <span class="date-separator">/</span>
      <div class="date-field short">
        <v-autocomplete
          v-model="mm"
          placeholder="Tháng (MM)"
          outlined
          dense
          hide-details
          @input="onMonthInput"
          @change="onMonthChange"
          ref="month"
          :items="months"
        />
      </div>
      <span class="date-separator">/</span>
      <div class="date-field long">
        <v-autocomplete
          v-model="yyyy"
          placeholder="Năm (YYYY)"
          outlined
          dense
          hide-details
          @input="emitDate"
          ref="year"
          :items="years"
        />
      </div>
    </div>
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['value'],
  data() {
    return {
      days: Array.from({length: 31}, (_, i) => (i + 1).toString().padStart(2, '0')),
      months: Array.from({length: 12}, (_, i) => (i + 1).toString().padStart(2, '0')),
      years: Array.from({length: 28}, (_, i) => (2000 + i).toString()),
      //
      dd: '',
      mm: '',
      yyyy: '',
      errorText: '',
    }
  },
  methods: {
    onDayInput() {
      if (this.dd.length === 2) this.$refs.month.focus()
      this.emitDate()
    },
    onMonthInput() {
      if (this.mm.length === 2) this.$refs.year.focus()
      this.emitDate()
    },
    onDayChange() {
      this.$refs.month.focus()
      this.emitDate()
    },
    onMonthChange() {
      this.$refs.year.focus()
      this.emitDate()
    },
    emitDate() {
      const {isValid, fullDate} = this.validate()
      if (!isValid) this.errorText = 'Vui lòng kiểm tra lại ngày sinh'
      else this.errorText = ''
      this.$emit('input', fullDate)
    },
    validate() {
      const fullDate = `${this.dd}/${this.mm}/${this.yyyy}`
      return {isValid: moment(fullDate, 'DD/MM/YYYY', true).isValid(), fullDate}
    },
  },
}
</script>

<style scoped>
.date-input-container {
  display: flex;
  align-items: center;
  gap: 8px; /* Space between inputs and slashes */
}

.date-separator {
  font-size: 1.2rem;
  font-weight: bold;
  color: #757575;
}

/* Control widths manually since we aren't using columns */
.date-field.short {
  width: 145px;
}
.date-field.long {
  width: 170px;
}

/* Optional: Center the text inside the inputs */
::v-deep .v-text-field input {
  text-align: center;
}
</style>